/* Testi che non vanno a capo: se non ci stanno, il corpo scende finche' entrano. */
(function () {
  var attesa = 0;
  function adatta() {
    var n = document.querySelectorAll('[data-ap-fit]');
    for (var i = 0; i < n.length; i++) {
      var e = n[i], box = e.parentNode;
      e.style.fontSize = '';
      var largo = box.clientWidth;
      if (!largo) continue;
      var base = parseFloat(window.getComputedStyle(e).fontSize);
      var testo = e.scrollWidth;
      if (testo > largo) e.style.fontSize = Math.max(15, base * (largo / testo) * 0.985) + 'px';
    }
  }
  function riadatta() { window.clearTimeout(attesa); attesa = window.setTimeout(adatta, 120); }
  function avvia() {
    adatta();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(adatta);
    window.setTimeout(adatta, 600);
  }
  window.addEventListener('resize', riadatta);
  document.addEventListener('shopify:section:load', riadatta);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia);
  else avvia();
})();
